import API from "@utils/plugins/API";

const FleetSegmentationService = {
  all: (params) => {
    return API.get("fleet-segmentations", { params: params });
  },
  create: (name, name_eng, description, alpha_code) => {
    return API.post("fleet-segmentations", {
      name,
      name_eng,
      description,
      alpha_code,
    });
  },
  update: (id, name, name_eng, description, alpha_code) => {
    return API.put(`fleet-segmentations/${id}`, {
      name,
      name_eng,
      description,
      alpha_code,
    });
  },
  find: (id) => {
    return API.get(`fleet-segmentations/${id}`);
  },
  destroy: (id) => {
    return API.delete(`fleet-segmentations/${id}`);
  },
};

export default FleetSegmentationService;
